'use client'

import { useTheme } from 'next-themes'
import { Toaster as Sonner, ToasterProps } from 'sonner'

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      // Lifted above an editor's action bar, which sits at the bottom of the
      // viewport where these toasts land: a "Draft saved" toast used to cover
      // the Save draft / Publish buttons it was reporting on (QA S-UI8 / PC-30).
      // `--editor-footer-h` is 0 on pages without such a bar (globals.css), so
      // everywhere else keeps sonner's own 32px / 16px.
      offset={{ bottom: 'calc(var(--editor-footer-h, 0px) + 32px)' }}
      mobileOffset={{ bottom: 'calc(var(--editor-footer-h, 0px) + 16px)' }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
